<div class="l-container">
  <div>
    <!--<div style="display: flex;padding-bottom: 16px;align-items: center;">
      <span class="sgd-spacer"></span>
      <mat-slide-toggle [checked]="themeService.themeSignal() === 'light'" (click)="toogleTheme()"></mat-slide-toggle>
      @if(themeService.themeSignal() === "dark"){
      <mat-icon>dark_mode</mat-icon>
      }@else{
      <mat-icon>light_mode</mat-icon>
      }
      <span class="sgd-spacer"></span>
    </div>-->
    <mat-card class="card-only-shadow">
      <mat-card-header style="justify-content: center;">
        <mat-card-title class="title">
          @if (logoPath) {
          <img [src]="logoPath" alt="Logo" style="filter:drop-shadow(0 0 0.05rem white)">
          }
          <p>
            {{systemName?systemName:'Ingreso de usuarios'}}
          </p>
        </mat-card-title>
        <mat-card-subtitle style="margin: 4px 0px 0px;line-height: normal;">
          {{institutionName?
          institutionName:
          "Ingrese los datos correctos para obtener acceso a la aplicaci&oacute;n"
          }}
        </mat-card-subtitle>
      </mat-card-header>
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <mat-card-content style="margin:16px 0px">
          <mat-form-field class="full-width" appearance="outline">
            <mat-icon matPrefix>person</mat-icon>
            <mat-label>Nombre de usuario</mat-label>
            @if(tmpUser.length === 0) {
            <input autoFocus type="text" formControlName="username" matInput>
            }@else {
              <input type="text" formControlName="username" matInput>
            }
          </mat-form-field>
          <br>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Contrase&ntilde;a</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            @if(tmpUser.length > 0) {
            <input autoFocus formControlName="password" matInput [type]="hide ? 'password' : 'text'">
            }@else {
              <input formControlName="password" matInput [type]="hide ? 'password' : 'text'">
            }
            <button type="button" mat-icon-button matSuffix (click)="clickEvent($event)"
              [attr.aria-label]="'Ocultar contrase&ntilde;a'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <div class="reset-password" (click)="resetPassword()"> Olvid&oacute; su  contrase&ntilde;a?</div>
          @if (loginFailed) {
          <p class="mat-mdc-card-subtitle">
            {{msgErrorLogin}}
          </p>
          }
        </mat-card-content>
        <mat-card-actions>
          <button mat-flat-button class="btn-login" type="submit" [disabled]="!loginForm.valid">
            <div class="btn-login-content">
              @if (fetchingLogin) {
              <mat-spinner diameter="20" color="warn"></mat-spinner>
              }@else{
              <p>Ingresar</p>
              }
            </div>
          </button>
        </mat-card-actions>
      </form>
    </mat-card>
  </div>
</div>
